import * as React from 'react'
// components
import Row from './components/Row'
import { Button, BUTTON_LAYOUTS, Table } from 'components/UI'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// constants
import { Modals } from 'constants/modals'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
import { SecurityProfilesContext } from 'containers/Security/components/SecurityProfiles/layers/API'
// view components
import SecurityProfileModal from 'components/Modals/SecurityProfileModal'
// views
import { Title, TitleWrapper } from 'themes/views/security'

const headers = [
  { id: 'name', sortable: false, left: true, label: 'NAME' },
  { id: 'createdAt', sortable: false, left: true, label: 'DATE CREATE' },
  { id: 'active', sortable: false, left: true, label: 'ACTIVE' }
]

const SecurityProfiles: React.FC = () => {
  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)
  const { data, refetch, totalCount, isRefetching } = React.useContext(SecurityProfilesContext)

  const { showModal } = useShowModal({ modalType: Modals.SECURITY_PROFILE_MODAL })

  return (
    <>
      <TitleWrapper>
        <Title>
          Profile allow access to functions to be enabled and disabled.Profiles and then to be referenced when setting
          up Object and Group security
        </Title>
        <Button onClick={() => showModal()} type='button' layout={BUTTON_LAYOUTS.PURPLE}>
          CREATE NEW
        </Button>
      </TitleWrapper>

      <Table
        data={data}
        page={page}
        headers={headers}
        perPage={perPage}
        refetch={refetch}
        totalCount={totalCount}
        isLoading={isRefetching}
        onPageChange={handleSetPage}
        onPerPageChange={handleSetPerPage}>
        {({ data }) => data.map((item) => <Row key={item.id} data={item} />)}
      </Table>

      <SecurityProfileModal />
    </>
  )
}

export default SecurityProfiles
